module.exports = __webpack_public_path__ + "img/medical_medicine_supplement.73a92b37.jpg";